if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.form.querySelector("[name=id]").disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cart =
          document.querySelector("cart-notification") ||
          document.querySelector("cart-drawer");
        this.submitButton = this.querySelector('[type="submit"]');
        if (document.querySelector("cart-drawer"))
          this.submitButton.setAttribute("aria-haspopup", "dialog");
        this.buyMembership = document.getElementById("accept_policy");
        this.memberProduct = document.querySelector(
          ".cc-pricing-table-wrap"
        )?.dataset?.elite;
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute("aria-disabled") === "true") return;

        this.handleErrorMessage();

        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");
        this.querySelector(".loading-overlay__spinner").classList.remove(
          "hidden"
        );

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const formData = new FormData(this.form);

        // Check if this is the EMG-001 product and force quantity to 1
        const variantId = formData.get("id");
        if (variantId) {
          // Get product data to check SKU
          fetch(`/products.json`)
            .then((response) => response.json())
            .then((data) => {
              const product = data.products.find((p) =>
                p.variants.some((v) => v.id == variantId)
              );
              if (product) {
                const variant = product.variants.find((v) => v.id == variantId);
                if (variant && variant.sku === "EMG-001") {
                  // Force quantity to 1 for EMG-001
                  formData.set("quantity", "1");
                }
              }
              this.processFormSubmission(formData, config);
            })
            .catch(() => {
              this.processFormSubmission(formData, config);
            });
        } else {
          this.processFormSubmission(formData, config);
        }
      }

      processFormSubmission(formData, config) {
        if (this.cart) {
          formData.append(
            "sections",
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append("sections_url", window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        if (this.buyMembership && this.buyMembership.checked) {
          setTimeout(async () => {
            const formData = {
              items: [
                {
                  id: this.memberProduct,
                  quantity: 1,
                  properties: { _type: "hide" },
                },
              ],
            };

            try {
              const response = await fetch(
                window.Shopify.routes.root + "cart/add.js",
                {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json",
                  },
                  body: JSON.stringify(formData),
                }
              );

              if (!response.ok) throw new Error("Failed to add item to cart");
              const data = await response.json();

              this.submitCartRequest(config);
            } catch (error) {
              console.error("Error adding item to cart:", error);
            }
          }, 500);
        } else {
          this.submitCartRequest(config);
        }
      }

      submitCartRequest(config) {
        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            console.log(response);
            if (response.status) {
              this.handleErrorMessage(response.description);

              const soldOutMessage =
                this.submitButton.querySelector(".sold-out-message");
              if (!soldOutMessage) return;
              this.submitButton.setAttribute("aria-disabled", true);
              this.submitButton.querySelector("span").classList.add("hidden");
              soldOutMessage.classList.remove("hidden");
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: "product-form",
              });
            this.error = false;
            if (
              [
                32435612745808, 32435461095504, 32435481641040, 32929677213776,
              ].includes(response.id)
            ) {
              window.location = "/cart";
              return;
            }

            const quickAddModal = this.closest("quick-add-modal");
            if (quickAddModal) {
              document.body.addEventListener(
                "modalClosed",
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove("loading");
            if (this.cart && this.cart.classList.contains("is-empty"))
              this.cart.classList.remove("is-empty");
            if (!this.error) this.submitButton.removeAttribute("aria-disabled");
            this.querySelector(".loading-overlay__spinner").classList.add(
              "hidden"
            );
          });
      }

      handleErrorMessage(errorMessage = false) {
        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
